export const fetching = (state) => ({ ...state, isFetching: true, hasError: false });
export const fetchSuccess = (state) => ({ ...state, isFetching: false, hasError: false });
export const fetchFail = (state) => ({ ...state, isFetching: false, hasError: true });
